import { useRef, useState } from 'react';
import PinchZoomPan from 'react-responsive-pinch-zoom-pan';
import './RotatableImage.css';

const RotatableImage = ({ src, alt = 'Rotatable Image', maxScale = 10 }) => {
  const [rotation, setRotation] = useState(0);
  const pinchZoomRef = useRef(null);

  const rotateImage = (angle) => {
    const newRotation = (rotation + angle) % 360;
    setRotation(newRotation);
  };

  const resetTransform = () => {
    setRotation(0);
    // Reset zoom and pan if the component exposes reset method
    if (pinchZoomRef.current && pinchZoomRef.current.reset) {
      pinchZoomRef.current.reset();
    }
  };

  return (
    <div>
      <div className="rotation-controls">
        <button
          className="rotation-btn"
          onClick={() => rotateImage(-90)}
          aria-label="Rotate left 90 degrees"
        >
          ↺ 90°
        </button>
        <button
          className="rotation-btn reset-btn"
          onClick={resetTransform}
          aria-label="Reset rotation and zoom"
        >
          Reset
        </button>
        <button
          className="rotation-btn"
          onClick={() => rotateImage(90)}
          aria-label="Rotate right 90 degrees"
        >
          90° ↻
        </button>
      </div>

      <div className="image-viewport">
        <PinchZoomPan
          ref={pinchZoomRef}
          maxScale={maxScale}
          minScale={0.5}
          initialScale={1}
          position="center"
        >
          <div className="image-wrapper">
            <img
              src={src}
              alt={alt}
              style={{
                transform: `rotate(${rotation}deg)`,
                width: '100%',
                height: 'auto',
                display: 'block',
                transition: 'transform 0.3s ease-in-out'
              }}
            />
          </div>
        </PinchZoomPan>
      </div>
    </div>
  );
};

export default RotatableImage;
